
/* styles */
require("!!../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-04eaec87&scoped=true!sass-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./aggregate-list.vue")

var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./aggregate-list.js"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-04eaec87!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./aggregate-list.vue"),
  /* scopeId */
  "data-v-04eaec87",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/aggregate/aggregate-list.vue
// module id = 1893
// module chunks = 1